module.exports = __webpack_public_path__ + "img/popup.c7576ff2.png";